import React from 'react';
import { ReactTemplate } from '@bingads-webui-react/react-template';
import { I18nModel } from '@bingads-webui/copilot-i18n';
import { BannerAction, BannerError, BannerState } from './types';

export interface BannerStateConfig {
  title?: string;
  description?: React.ReactNode;
  actions?: BannerAction[];
}

export const getBannerStatesConfig = (i18n: I18nModel): Record<BannerState, BannerStateConfig> => ({
  Init: {
  },
  Generating: {
    title: i18n.getString(_TL_('We\'re generating AI-powered asset recommendations...')),
    actions: ['generating'],
  },
  GeneratingFailed: {
    title: i18n.getString(_TL_('We can\'t generate asset recommendations from this Final URL')),
    description: i18n.getString(_TL_('Please enter a different Final URL and try again.')),
  },
  GeneratingSucceeded: {
    title: i18n.getString(_TL_('Customize your recommended assets')),
    description: i18n.getString(_TL_('Describe the assets you want to create, select one or multiple themes and we\'ll generate AI-powered asset recommendations tailored to your campaign.')),
    actions: ['update'],
  },
  Applying: {
    title: i18n.getString(_TL_('Generating new asset recommendations')),
    description: i18n.getString(_TL_('Some of the recommended assets will be added to your asset group.')),
    actions: ['applying'],
  },
  ApplyingFailed: {
    title: i18n.getString(_TL_('Entity limit is reached.')),
    description: i18n.getString(_TL_('You\'ve reached the limit of multiple types of assets that can be added. Please remove some and add the new recommendations.')),
    actions: ['refresh', 'reset'],
  },
  ApplyingSucceeded: {
    title: i18n.getString(_TL_('Refine your asset recommendations')),
    description: <ReactTemplate
      template={i18n.getString(_TL_('Select {{b}}Refine{{/b}} to get updated recommendations by providing new descriptions or select {{b}}Remove assets{{/b}} to remove all assets from the current asset group.'))}
      model={{
        b: (text: string) => (<b>{text}</b>),
      }}
    />,
    actions: ['refresh', 'reset'],
  },
});

export interface BannerErrorMsgConfig {
  title: string;
  description: string;
}

export const getBannerErrorMsgs = (i18n: I18nModel): Record<BannerError, BannerErrorMsgConfig> => ({
  NoRecommendation: {
    title: i18n.getString(_TL_('We can\'t generate asset recommendations from this Final URL')),
    description: i18n.getString(_TL_('Please enter a different Final URL and try again.')),
  },
  TooManyRequests: {
    title: i18n.getString(_TL_('You\'ve requested more asset recommendations than we can provide')),
    description: i18n.getString(_TL_('We can\'t generate more asset recommendations. Please try again later.')),
  },
});
